export const NotFound = () => (
    <>
        <div className="flex items-center justify-center h-screen">
            <h1 className="text-9xl">Oops, Sorry. Page Not Found</h1>
        </div>
    </>);
